import { FTMarketIds } from "../../typings";

export const isMarketType = (marketTypeId: string, marketType: string) => {
    return FTMarketIds[marketType].indexOf(marketTypeId) > -1
}